<template>
    <div>

        <v-dialog light persistent v-model="showDetailDialog" class="cardUp" width="500px" scrollable
            style="max-width:500px;">
            <v-layout align-center column justify-center class="cardStats" style="height:100%">
                <table v-if="currentItem != undefined" style="width: 100%" class="">
                    <tr>
                        <td width="70%" class="cardStatsHeader  pa-1" colspan=4>
                            <strong style="float: left">
                                <span class="mr-2 ml-1 white--text pl-1 pr-1"
                                    style="border: 1px solid white; border-radius: 5px;">{{
                                        currentItem.pettorale }}</span>

                                <country-flag :country="currentItem.nazione" size="small" class="" />
                                {{ currentItem.cognome }}
                                {{ currentItem.nome }}
                                <br />
                                <span class="ml-3">
                                    <small>{{ currentItem.team }} </small></span>
                            </strong>
                            <v-icon @click="closeDetail()" class="ma-0 pa-0 white--text"
                                style="float:right">close</v-icon>
                        </td>
                    </tr>
                </table>
                <table v-if="currentItem != undefined" style="width: 100%" class="mb-3">
                    <tr>
                        <td width="30%" class="pr-2 frazioniTitle frazioniValueR">Divisione</td>
                        <td width="70%" class="frazioniValue"><strong>{{ currentItem.divisione }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <td class="pr-2 frazioniTitle frazioniValueR">Pos. Ass.</td>
                        <td class="frazioniValue "><strong>{{ currentItem.posizione }}°</strong></td>
                    </tr>
                    <tr>
                        <td class="pr-2 frazioniTitle frazioniValueR">Pos. Div.</td>
                        <td class="frazioniValue "><strong>{{ currentItem.posizioneDivisione }}°</strong></td>
                    </tr>
                    <tr>
                        <td class="pr-2 frazioniTitle frazioniValueR">Pos. Cat.</td>
                        <td class="frazioniValue "><strong>{{ currentItem.posizioneCategoria }}°</strong> - Cat:
                            <strong>{{ currentItem.cat }}</strong>
                        </td>
                    </tr>
                </table>
                <table v-if="currentItem != undefined" style="width: 100%" class="mb-3">
                    <tr>
                        <td width="10%" class="backColor cardStatsHeader"><small>Passaggio</small></td>
                        <td width="10%" class="backColor cardStatsHeader"><small>Fraz</small></td>
                        <td width="10%" class="backColor cardStatsHeader"><small>P.F.</small></td>
                        <td width="10%" class="backColor cardStatsHeader"><small>Tempo</small></td>
                        <td width="10%" class="backColor cardStatsHeader"><small>Pos</small></td>
                    </tr>
                    <tr v-for="(segmento, index) in segments"
                        :key="'titoloDettaglio' + currentItem.pettorale + segmento" v-if="segmento != 'LIVE'"
                        :class="index % 2 == 0 ? 'grey lighten-3' : ''">
                        <td align="right"><small class="mr-1"><strong>{{ segmento }}</strong></small></td>
                        <td align="center"><small>{{ formatTime(getValoreCampoSplit(currentItem, 'passaggio', segmento),
                            "Running") }} </small></td>
                        <td align="center"><small>{{ getValoreCampoSplit(currentItem, 'posizioneFrazione', segmento) }}
                            </small></td>
                        <td align="center"><small>{{ formatTime(getValoreCampoSplit(currentItem, 'tempo', segmento),
                            "Running") }} </small></td>
                        <td align="center"><small>{{ getValoreCampoSplit(currentItem, 'posizioneDivisione', segmento) }}
                            </small></td>
                    </tr>
                </table>

                <v-btn round outline small class="black  black--text" @click="closeDetail()">Chiudi</v-btn>
            </v-layout>
        </v-dialog>



        <v-toolbar app color="black" dark>
            <span @click="gotoHome()" class="mr-0"><v-icon class="home" color="white">home</v-icon></span>
            <v-toolbar-title data-cy="titleBtn">
                <img class="menuLogo mt-2" src="../assets/images/logo_icron_2.0_bianco.png" style="height: 30px" />
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-layout v-if="isDesktopMode()" align-start row justify-center class="primaryColor darken-2 p-0 m-0"
                style="border-radius: 10px 10px 10px 10px"><span class="white--text"><strong>{{ reportId
                        }}</strong> |
                    Live
                    results
                </span>
            </v-layout>
            <v-spacer></v-spacer>


            <v-icon class="mr-4" @click="filterToggle = !filterToggle">search</v-icon>
            <v-icon v-if="!starred" @click="showStarred()">star</v-icon>
            <v-icon v-else color="yellow" @click="showStarred()">star</v-icon>
        </v-toolbar>




        <v-layout align-start row wrap justify-center class="pa-0 black--text grey lighten-4 ">
            <v-flex v-if="isMobileMode()" flex xs12 sm12 md12 lg12 class="backColor white--text title mt-0 pa-1">
                <small>{{ reportId }}</small>
            </v-flex>
            <v-flex flex xs12 sm12 md12 lg12 class="primaryColor white--text title mt-0 pa-2">
                <small><strong>{{ report.description }}</strong></small>
                <span v-if="mista" style="float:right"><small @click="changeSesso(undefined)"
                        :class="'ml-1 ' + (filtroSesso == undefined ? 'selected' : '')">GEN</small>
                    - <small @click="changeSesso('M')"
                        :class="'ml-1 ' + (filtroSesso == 'M' ? 'selected' : '')">M</small>
                    - <small @click="changeSesso('F')" :class="'ml-1 mr-2 ' + (filtroSesso == 'F' ? 'selected' : '')">
                        F</small></span>
            </v-flex>

            <v-flex flex xs12 sm12 md12 lg12 class="grey lighten-2 black--text pa-1 " v-if="false">
                <span class="mt-0"><v-select @change="changeSegment" class="text--white pa-0" hint="Passaggio/Segmento"
                        :items="segments" v-model="segment" label="Cambia segmento" single-line
                        persistent-hint></v-select>
                </span>
            </v-flex>

            <v-layout align-center row wrap justify-center class="grey lighten-2 black--text pa-1 ">
                <table width=100%>
                    <tr>
                        <td align="left" width="15%" @click="changeSplit('-')"><v-icon color="black">arrow_left</v-icon>
                        </td>
                        <td align="center">
                            <span class="mt-0"><v-select @change="changeSegment" class="text--white pa-0"
                                    hint="Passaggio/Segmento" :items="segments" v-model="segment" single-line
                                    persistent-hint></v-select>
                            </span>
                        </td>
                        <td align="right" width="15%" @click="changeSplit('+')"><v-icon
                                color="black">arrow_right</v-icon>
                        </td>
                    </tr>
                </table>
            </v-layout>


            <v-flex v-if="segment == 'LIVE'" flex xs12 sm12 md12 lg12 class="black--text title mt-0 ">
                <v-data-table :items="itemsF" hide-actions hide-headers style="" class="mb-5">
                    <template slot="items" slot-scope="props" class="scroll-y" style="height: 600px">
                        <tr style="height:0px">
                        </tr>
                        <tr v-if="props.item.raggr == true" class="white display-2">
                            <td colspan="10"></td>
                        </tr>
                        <tr v-if="props.item.raggr == true" class="backColor white--text">
                            <td colspan="10" class="pa-1" align="center">
                                <strong>{{ (props.item.splitName) }}</strong>
                            </td>
                        </tr>
                        <tr v-if="props.item.raggr == true && isDesktopMode()" class="grey black--text">
                            <td align="center">Pref</td>
                            <td align="center">Pos</td>
                            <td align="center">Atleta</td>
                            <td align="center">Pett</td>
                            <td align="center">Cat</td>
                            <td align="center">P.Cat.</td>
                            <td align="center">Team</td>
                            <td align="center">Tempo</td>
                            <td align="center">Gap</td>
                            <td> </td>
                        </tr>
                        <tr v-if="isDesktopMode()" style="height:20px"
                            :class="props.index % 2 == 0 ? 'grey lighten-3' : ''">
                            <td align="center" width="10px" @click="starToggle(props.item)"
                                style="padding: 0px 0px !important;">
                                <v-icon small class="ml-1" v-if="props.item.starred" color="orange">star</v-icon>
                                <v-icon small class="ml-1" v-else>star_outline</v-icon>
                            </td>
                            <td @click="starToggle(props.item)" width="5%" align="center"
                                style="padding: 0px 10px !important;">
                                <strong v-if="filtroSesso == undefined">{{ getStato(props.item.posizione) }}</strong>
                                <strong v-else>{{ getStato(props.item.posizioneMF) }}</strong>
                            </td>
                            <td @click="starToggle(props.item)" nowrap style="padding: 0px 10px !important;">
                                <country-flag :country="props.item.nazione" size="small" /> {{
                                    props.item.atleta }}
                            </td>
                            <td width="5%" align="center">
                                {{ props.item.pettorale }}
                            </td>
                            <td width="5%" align="center">
                                {{ props.item.cat }}
                            </td>
                            <td width="5%" align="center">
                                {{ getStato(props.item.posizioneCategoria) }}
                            </td>
                            <td align="left" nowrap>
                                {{ props.item.team }}
                            </td>
                            <td align="center">
                                <strong>{{ formatTime(props.item.tempo, 'Running') }}</strong>
                            </td>
                            <td width="5%" align="center" style="padding: 0px 10px !important;">
                                <small v-if="props.item.posizione > 1">
                                    <i class="red--text">{{ props.item.distacco }}</i>
                                </small>
                            </td>
                            <td width="5%" align="center" no-wrap style="padding: 0px 10px !important;">
                                <v-icon @click="showDetail(props.item)" style="float: right;"
                                    small>view_headline</v-icon>
                            </td>
                        </tr>
                        <tr v-else style="height:30px" :class="props.index % 2 == 0 ? 'grey lighten-3' : ''">

                            <td align="center" width="10px" @click="starToggle(props.item)"
                                style="padding: 0px 0px !important;">
                                <v-icon small class="ml-1" v-if="props.item.starred" color="orange">star</v-icon>
                                <v-icon small class="ml-1" v-else>star_outline</v-icon>
                            </td>
                            <td @click="starToggle(props.item)" width="2%" align="center"
                                style="padding: 0px 0px !important;">
                                <strong v-if="filtroSesso == undefined">{{ getStato(props.item.posizione) }}.</strong>
                                <strong v-else>{{ getStato(props.item.posizioneMF) }}.</strong>
                            </td>
                            <td @click="starToggle(props.item)" width="80%" align="left"
                                style="padding: 0px 0px !important;">
                                <strong class=""> {{ props.item.atleta }}</strong>
                            </td>
                            <td width="5%" style="padding: 0px 10px !important;"> <country-flag
                                    :country="props.item.nazione" size="small" /></td>
                            <td width="10%" align="right" no-wrap style="padding: 0px 10px !important;">
                                <strong>
                                    {{ formatTime(getValoreCampoSplit(props.item, 'tempo'), "Running") }}
                                </strong>
                                <small>
                                    <i class="red--text">{{ formatTime(getValoreCampoSplit(props.item, 'distacco'), "Running") }}</i>
                                </small>
                            </td>
                            <td width="5%" align="center" no-wrap style="padding: 0px 10px !important;">
                                <v-icon @click="showDetail(props.item)" style="float: right;"
                                    small>view_headline</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>

            <v-flex v-else flex xs12 sm12 md12 lg12 class="black--text  mt-3 ">
                <v-layout align-center row wrap justify-center class="backColor white--text">
                    <strong>{{ segment }}</strong>
                </v-layout>
                <v-data-table :items="removeNull(itemsF)" hide-actions hide-headers style="" class="mb-5">
                    <template slot="items" slot-scope="props" class="scroll-y" style="height: 600px">
                        <tr style="height:0px">
                        </tr>
                        <tr v-if="isDesktopMode() && props.index == 0" class="grey black--text">
                            <td align="center">Pref</td>
                            <td align="center">Pos</td>
                            <td align="center">Atleta</td>
                            <td align="center">Pett</td>
                            <td align="center">Cat</td>
                            <td align="center">P.Cat.</td>
                            <td align="center">Team</td>
                            <td align="center">Frazione</td>
                            <td align="center">Pos.Fraz</td>
                            <td align="center">Tempo</td>
                            <td align="center">Gap</td>
                            <td></td>
                        </tr>
                        <tr v-if="isDesktopMode()" style="height:20px"
                            :class="props.index % 2 == 0 ? 'grey lighten-3' : ''">
                            <td align="center" width="10px" @click="starToggle(props.item)"
                                style="padding: 0px 0px !important;">
                                <v-icon small class="ml-1" v-if="props.item.starred" color="orange">star</v-icon>
                                <v-icon small class="ml-1" v-else>star_outline</v-icon>
                            </td>
                            <td @click="starToggle(props.item)" width="5%" align="center">
                                <strong v-if="filtroSesso == undefined">{{ getStato(getValoreCampoSplit(props.item,
                                    'posizione')) }}</strong>
                                <strong v-else>{{ getStato(getValoreCampoSplit(props.item, 'posizioneMF')) }}</strong>
                            </td>
                            <td @click="starToggle(props.item)" nowrap style="padding: 0px 10px !important;">
                                <country-flag :country="props.item.nazione" size="small" /> {{
                                    props.item.atleta }}
                            </td>
                            <td width="5%" align="center">
                                {{ props.item.pettorale }}
                            </td>
                            <td width="5%" align="center">
                                {{ props.item.cat }}
                            </td>
                            <td width="5%" align="center">
                                <strong>{{ getStato(getValoreCampoSplit(props.item, 'posizioneCategoria')) }}</strong>
                            </td>
                            <td align="left" nowrap>
                                {{ props.item.team }}
                            </td>
                            <td width="10%" align="center">
                                {{ formatTime(getValoreCampoSplit(props.item, 'passaggio'), "Running") }}
                            </td>
                            <td width="10%" align="center">
                                {{ getStato(getValoreCampoSplit(props.item, 'posizioneFrazione')) }}
                            </td>
                            <td width="10%" align="center">
                                <strong>{{ formatTime(getValoreCampoSplit(props.item, segment), "Running") }}</strong>
                            </td>
                            <td width="10%" align="center">
                                <small v-if="getValoreCampoSplit(props.item, 'posizione') !== 1">
                                    <i>+{{ formatTime(getValoreCampoSplit(props.item, 'leaderDiff'), "Running") }}</i>
                                </small>
                            </td>
                            <td width="5%" align="right" no-wrap style="padding: 0px 10px !important;">
                                <v-icon @click="showDetail(props.item)" style="float: right;"
                                    small>view_headline</v-icon>
                            </td>
                        </tr>
                        <tr v-else style="height:30px" :class="props.index % 2 == 0 ? 'grey lighten-3' : ''">
                            <td align="center" width="20px" @click="starToggle(props.item)"
                                style="padding: 0px 0px !important;">
                                <v-icon small class="ml-1" v-if="props.item.starred" color="orange">star</v-icon>
                                <v-icon small class="ml-1" v-else>star_outline</v-icon>
                            </td>
                            <td @click="starToggle(props.item)" width="2%" align="center"
                                style="padding: 0px 0px !important;">
                                <strong class="ml-1" v-if="filtroSesso == undefined">{{
                                    getStato(getValoreCampoSplit(props.item, 'posizione')) }}</strong>
                                <strong class="ml-1" v-else>{{ getStato(getValoreCampoSplit(props.item, 'posizioneMF'))
                                    }}</strong>
                            </td>
                            <td @click="starToggle(props.item)" width="80%" align="left"
                                style="padding: 0px 0px !important;">
                                <strong>{{ props.item.atleta }}</strong>
                            </td>
                            <td width="5%" style="padding: 0px 10px !important;"> <country-flag
                                    :country="props.item.nazione" size="small" /></td>
                            <td width="10%" align="right" no-wrap style="padding: 0px 10px !important;">
                                <strong>
                                    {{ formatTime(getValoreCampoSplit(props.item, 'tempo'), "Running") }}
                                </strong>
                                <small>
                                    <i>+{{ formatTime(getValoreCampoSplit(props.item, 'dist'), "Running") }}</i>
                                </small>
                            </td>
                            <td width="5%" align="right" no-wrap style="padding: 0px 10px !important;">
                                <v-icon @click="showDetail(props.item)" style="float: right;"
                                    small>view_headline</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>




        </v-layout>
        <v-footer v-if="filterToggle" fixed class="p-0 grey darken-2" style="height: 30px;">
            <v-layout align-start row wrap justify-center style="width:100%; ">
                <v-flex flex xs12 sm12 md12 lg12 class="white pa-2">
                    <v-text-field class="white red--text pa-0" style="width:100%;" v-model="searchText"
                        label="Cerca cognome, team, pettorale o categoria" outline clearable append-icon="search"
                        @input="changedSearch"></v-text-field>
                </v-flex>
            </v-layout>
        </v-footer>

    </div>
</template>


<script>


export default {
    components: {
    },
    name: 'ICRONIUM-RR-LIVE',

    data() {
        return {

            myInterval: undefined,
            showAddTimingSourceDialog: false,
            name: '',
            sync: '00:00:00.000',

            tpSelected: undefined,

            timingPoint: undefined,

            items: [],
            itemsF: [],

            fields: [],

            filterKey: undefined,
            filterValue: undefined,
            searchText: '',
            direction: true,
            orderByField: 'posizione',

            coloriSplit: {},

            showColumn: 'frazioni',
            showColors: false,

            currentItem: undefined,
            showDetailDialog: false,

            filtroSesso: undefined,

            busyChannel: false,

            cacheKey: "null",

            raceInfo: {},

            report: {},

            searchText: undefined,
            filterToggle: false,

            segments: [],
            segment: 'LIVE',

            color: "#0D3D58",
            starred: false,
            mapStars: {},

            jsonVersion: -1,

            mista: false,

            touchstartX: -1,
            touchstartY: -1,
            touchendX: -1,
            touchendY: -1,

            home: true,

            token: undefined,

            eventId: '',
            reportId: ''


        };
    },

    created() {
        window.addEventListener('keydown', this.doCommand);
        //window.addEventListener('touchstart', this.handleGesture);
        //window.addEventListener('touchend', this.handleGesture);

    },
    destroyed() {
        window.removeEventListener('keydown', this.doCommand);
        // window.removeEventListener('touchstart', this.handleGesture);
        //window.removeEventListener('touchend', this.handleGesture);
    },



    mounted() {
        this.reportId = this.$route.params.reportId;
        this.eventId = this.$route.params.eventId;


        this.mapStars = helper.ls.get('ICRONSTARS' + this.reportId);
        if (this.mapStars == undefined) {
            this.mapStars = {};
            helper.ls.set('ICRONSTARS' + this.reportId, this.mapStars);
        }


        clearInterval(this.myInterval);
        this.myInterval = setInterval(this.refresh, 3000, this);
        this.checkReport()
    },


    beforeDestroy() {
        clearInterval(this.myInterval);
    },

    methods: {

        refresh: function (self) {
            self.checkReport();
        },

        checkReport() {

            if (this.busyChannel) {
                console.log("Attendo chiamata precedente")
                return;
            }

            this.busyChannel = true;
            let _url = this.getApiURL() + "viewreport/" + this.reportId + ".version";
            if (true || window.location.hostname.indexOf("icron.it") != -1) {
                _url = "https://www.icron.it/IcronLiveServices/services/live/getCacheLiveData?dataId=" + this.eventId+ "_" + this.reportId;
                if (this.token != undefined) {
                    _url += "&token=" + this.token;
                }
                this.getCall(_url).then((response) => {
                    this.busyChannel = false;
                    if (response.esito == 'OK') {
                        //NO_DATA, NO_CHANGES, NEW_DATA, TOKEN_NOTVALID

                        if (response.dataStatus != undefined && response.dataStatus != '') {
                            if (response.dataStatus == 'NEW_DATA') {
                                this.token = response.token
                                this.updateData((response.data))
                            } else if (response.dataStatus == 'TOKEN_NOTVALID') {
                                this.token = undefined
                            }
                        }
                    }
                });
            } else {

                this.getCall(_url).then((response) => {
                    if (response.jsonVersion != undefined) {
                        if (response.jsonVersion != this.jsonVersion) {
                            console.log("jsonVersion aggiornato: " + response.jsonVersion + " <--> " + this.jsonVersion)
                            if (!this.busyChannel) {
                                console.log("richiamo nuovo JSON")
                                this.loadReport(response.jsonVersion);
                            } else {
                                console.log("Attendo chiamata precedente")
                            }
                        } else {
                            console.log("JSON non cambiato")
                        }
                    }
                });

            }


        },

        updateData(csvText) {

            console.log(csvText);

            // =========================
            // 1) Split righe
            // =========================

            const lines = csvText
                .trim()
                .split('\n')
                .filter(l => l.trim() !== '');

            if (lines.length < 2) {
                this.items = [];
                return;
            }

            // =========================
            // 2) Header
            // =========================

            const headers = lines[0]
                .split(';')
                .map(h => h.trim());


            // Trovo l'indice di TEMPO
            const tempoIndex = headers.indexOf("SPLIT");

            // Prendo tutto dopo TEMPO
            this.segments = headers.slice(tempoIndex + 1);



            // =========================
            // 3) Parse righe → oggetti
            // =========================

            const rows = lines.slice(1).map(line => {

                const values = line.split(';');

                let obj = {};

                headers.forEach((h, i) => {
                    obj[h] = values[i] || '';
                });

                return obj;
            });

            // =========================
            // 4) Normalizza dati
            // =========================

            let progr = 1;
            let sessoMap = {};

            this.items = rows.map(r => {

                const item = {

                    progr: progr++,

                    pettorale: r["PETT"],
                    atleta: r["ATLETA"],
                    cat: r["CAT"],
                    posizioneCategoria: r["P.CAT"],
                    team: r["SQUADRA"],
                    tempo: r["TEMPO"],
                    sesso: r['SESSO'],
                    nazione: r['NAZ'],
                    distacco: r['GAP'],
                    posizione: r['POS'],

                    starred: false,


                    splitName: r["SPLIT"],
                };

                this.segments.forEach(seg => {
                    item[seg] = r[seg]
                })

                // stelle
                item.starred =
                    this.mapStars[item.id] === true;

                sessoMap[item.sesso] =
                    item.sesso;

                return item;
            });

            let lastSplit = undefined;
            this.items.forEach(it => {
                if (it.split != lastSplit) {
                    it.raggr = true;
                    lastSplit = it.split
                    console.log(">>", lastSplit, ">>", it.atleta, ">>", it.raggr)

                } else {
                    it.raggr = false;
                }
            })



            if (this.segments.length > 0) {
                this.segments.unshift("LIVE")
            }


            this.mista = Object.keys(sessoMap).length > 1;


            this.busyChannel = false;
            this.itemsF = this.items
            this.itemsF = this.filteredList();
            //this.jsonVersion = newJsonVersion
        },

        doCommand(e) {

            console.log(">" + e.keyCode)
            let index = this.segments.indexOf(this.segment);
            if (e.keyCode == 37) {
                // sinistra
                if (index > 0) {
                    this.segment = this.segments[index - 1]
                } else {
                    this.segment = this.segments[0]
                }
                this.changeSegment(this.segment)
            } else if (e.keyCode == 39) {
                // destra
                if (index < this.segments.length - 1) {
                    this.segment = this.segments[index + 1]
                } else {
                    this.segment = this.segments[0]
                }
                this.changeSegment(this.segment)
            } else if (e.keyCode == 38) {
                this.segment = "LIVE"
                this.changeSegment(this.segment)
            }
        },

        handleGesture(event) {

            let touchendX = event.changedTouches[0].screenX;
            let touchendY = event.changedTouches[0].screenY;
            if (touchendX < touchstartX) {
                console.log('Swiped Left');
                this.doCommand({ keyCode: 37 })
            }

            if (touchendX > touchstartX) {
                console.log('Swiped Right');
                this.doCommand({ keyCode: 39 })
            }

            if (touchendY < touchstartY) {
                console.log('Swiped Up');
            }

            if (touchendY > touchstartY) {
                console.log('Swiped Down');
            }

            if (touchendY === touchstartY) {
                console.log('Tap');
            }
        },

        changeSplit(direction) {
            if (direction == '+') {
                this.doCommand({ keyCode: 39 })
            } else {
                this.doCommand({ keyCode: 37 })
            }
        },





        changeSegment(selectObj) {
            if (selectObj == 'LIVE') {
                this.items.sort((a, b) => {
                    return a.progr - b.progr
                });
                this.itemsF = this.filteredList();

            } else {
                this.orderByField = selectObj;
                this.orderBySplit(selectObj)
                this.itemsF = this.filteredSplit();
                this.itemsF = this.filteredList();

            }


        },


        removeNull(lista) {
            let listaFilt = [];
            lista.forEach(it => {
                let valoreA = this.getValue(this.orderByField, it);
                console.log(valoreA)
                if (valoreA !== "")
                    listaFilt.push(it)
            })

            return listaFilt;
        },

        getStato(val) {
            const valore = parseInt(val)

            if (valore == 9997 || valore == 999997) return "DSQ"
            else if (valore == 9998 || valore == 999998) return "DNF"
            else if (valore == 9999 || valore == 999999) return "DNS"
            return val

        },

        getValoreCampoSplit(item, campo, _segment) {

            if (_segment == undefined)
                _segment = this.segment


            return item[campo]


        },

        showDetail(item) {
            this.currentItem = item;
            this.showDetailDialog = true;
        },



        starToggle(item) {
            //console.log(item)
            if (this.mapStars[item.id] !== undefined) {
                this.mapStars[item.id] = !this.mapStars[item.id];
            } else {
                this.mapStars[item.id] = true;
            }
            helper.ls.set('ICRONSTARS' + this.reportId, this.mapStars);
            item.starred = !item.starred

            this.itemsF = this.filteredList()
            if (this.itemsF.length == 0) {
                // alert("Nessun atleta nella lista dei preferiti. Selezionare almeno una stellina ")
                this.starred = false
            }

            this.checkReport()

        },

        showStarred() {
            this.starred = !this.starred
            this.itemsF = this.filteredList();

            if (this.itemsF.length == 0) {
                alert("Nessun atleta nella lista dei preferiti. Selezionare almeno una stellina ")
                this.starred = !this.starred
                this.itemsF = this.filteredList();
            }

        },




        getValue(split, result) {

            console.log(split, result)
            return result[split];

        },

        formatValue(value, split) {

            if (value == '00:00:00.000' && split.type == 'Distacco') return ""

            if (split.type !== undefined && split.type !== null && split.type.toUpperCase().indexOf("TEMPO") !== -1 && value != '-' && value != undefined) {
                return this.formatTimestamp(value, split.format);
            }
            if (value == undefined) return "";
            return value;
        },

        formatTime(value, sport) {
            //console.log(value)
            if (value != undefined && sport == 'Running' && value.indexOf(".") != -1) {
                let valueTok = value.split(".")
                return this.riduci(valueTok[0])
            }
            return this.riduci(value);
        },


        getCellColor(split, item) {

            const value = this.getValue(split, item)

            if (value == 'DNF') return "orange lighten-2 black--text font-weight-black "
            else if (value == 'DNS') return "grey lighten-2 black--text font-weight-black "
            else if (value == 'DSQ') return "red white--text font-weight-black "

            const field = item.mappaFields[split.fieldSource];

            let addStyle = " ";
            if (split.color == 'green' || split.color == 'blue') addStyle = " white--text font-weight-black "

            if (!!field && field.note == 'MIN') return "green lighten-4 black--text font-weight-black "
            else if (!!field && field.note == 'MAX') return "orange lighten-2 black--text font-weight-black "
            else if (!!field && field.note == 'ALERT') return "red white--text font-weight-black "
            else if (value == "-") return "red";
            return split.color + addStyle
        },

        closeDetail() {
            this.showDetailDialog = false;
            this.selectedResult = undefined;
        },

        filteredList() {
            var listaSearch = this.items;

            if (this.searchText !== '' && this.searchText != null) {
                //console.log("Filtro locale:" + this.searchText)
                listaSearch = this.items.filter((p) => {
                    let res =
                        p != null &&
                        p.atleta != null &&
                        p.atleta.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;
                    let res1 =
                        p != null &&
                        p.team != null &&
                        p.team.toUpperCase().indexOf(
                            this.searchText.toUpperCase()
                        ) !== -1;

                    let res2 =
                        p != null &&
                        p.pettorale != null &&
                        p.pettorale == this.searchText;

                    let res3 =
                        p != null &&
                        p.cat != null &&
                        p.cat == this.searchText;

                    let resTot = res || res1 || res2 || res3;
                    return resTot;
                });
            }

            if (this.starred) {
                listaSearch = listaSearch.filter(p => {
                    return p.starred == true;
                })
            }

            if (this.filtroSesso != undefined) {
                listaSearch = listaSearch.filter(p => {
                    return p.sesso == this.filtroSesso;
                })
            }

            let lastRaggr = undefined;
            listaSearch.forEach(it => {
                if (it.splitName != lastRaggr) {
                    it.raggr = true;
                    lastRaggr = it.splitName
                } else {
                    it.raggr = false;
                }
            })

            return listaSearch;
        },

        changeSesso(sex) {
            this.filtroSesso = sex;
            this.itemsF = this.filteredList()
        },

        orderBySplit(split) {

            this.orderByField = split;
            this.itemsF = this.filteredSplit();
        },

        filteredSplit() {
            var listaSearch = this.items;
            listaSearch.sort(this.splitCompare);
            return listaSearch;
        },

        splitCompare(a, b) {
            return this.compareSplit(a, b)
        },

        compareSplit(a, b,) {
            const molti = 1;

            let valoreA = this.getValue(this.orderByField, a);
            let valoreB = this.getValue(this.orderByField, b);

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (!isNaN(valoreA) && !isNaN(valoreB)) {
                valoreA = parseFloat(valoreA);
                valoreB = parseFloat(valoreB);
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },



        catCompare(a, b, fieldName = 'cat') {

            let res = this.sexCompare(a, b);
            if (res != 0) return res;

            let molti = 1;

            let valoreA = a[fieldName];
            let valoreB = b[fieldName];

            let filtroTok = fieldName.split(".")
            if (filtroTok.length == 2) {
                valoreA = a[filtroTok[0]][filtroTok[1]];
                valoreB = b[filtroTok[0]][filtroTok[1]];
            }

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },


        sexCompare(a, b, fieldName = 'sesso') {
            let molti = 1;
            let filtroTok = fieldName.split(".")

            let valoreA = a[filtroTok[0]][filtroTok[1]];
            let valoreB = b[filtroTok[0]][filtroTok[1]];

            if (valoreA === undefined && valoreB == undefined) return 0;
            else if (valoreA === undefined) {
                return -1 * molti;
            } else if (valoreB === undefined) {
                return 1 * molti;
            }

            if (valoreA < valoreB) {
                return -1 * molti;;
            }
            if (valoreA > valoreB) {
                return 1 * molti;;
            }
            return 0;
        },


        changedSearch(event) {
            //  console.log('Changed:' + event);
            this.searchText = event;

            this.itemsF = this.filteredList();
        },

        gotoHome() {
            if (window.location.hostname.indexOf("icron.it") == -1) {
                let path = '/event/' + this.eventId
                this.$router.push(path)
            } else {
                window.location = "https://www.icron.it/live/event/" + this.eventId
            }
        }



    }
}
</script>
<style scoped>
td {
    height: 15px !important;
}

table.v-table tbody td {
    font-weight: 400;
    _font-size: 16px;
}

.backColor {
    background-color: #0D3D58;
    color: white;
    text-align: center
}

.primaryColor {
    background-color: #006064;
    color: white
}


.frazioniTitle {
    text-align: center;
    background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}

.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}

.frazioniValueR {
    text-align: right !important;
}

.frazioniTitleFinale {
    text-align: center;
    color: white;
    font-style: italic;
    _border: 1px solid lightgray;
    _border-radius: 0px 0px 7px 7px;
    _font-weight: bold;
}

.frazioniTitleFinaleDesk {
    text-align: center;
    color: white;
    font-style: italic;
    _border-radius: 0px 5px 5px 0px;
}

.frazioniTitleRow {
    text-align: center;
    background-color: lightgrey;
    _border-radius: 0px 0px 7px 7px;
}

.frazioniTitleRowDesk {
    text-align: center;
    background-color: lightgrey;
    _border-radius: 5px 0px 0px 5px;
}

.frazioniValueRow {
    text-align: center;
    background-color: rgb(243, 243, 243);
    _border-radius: 0px 0px 7px 7px;
}


.cardUp {
    background-color: #0D3D58;
    color: white;
    _border: 1px solid lightgray;
    border-radius: 10px 10px 0px 0px;
}

.cardStatsHeader {
    background-color: #0D3D58;
    color: white;
    border-radius: 10px 10px 0px 0px;
}

.cardStats {
    background-color: white;
    color: black;
    border: 2px solid lightgray;
    border-radius: 10px 10px 10px 10px;
}

.selected {
    background-color: white;
    color: black;
    border: 2px solid lightgray;
    border-radius: 5px;
    padding: 3px;
    font-weight: bold;
}

.home {
    background-color: #006064;
    color: white;
    border: 2px solid lightgray;
    border-radius: 5px;
    padding: 3px;
    font-weight: bold;
}
</style>
